function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20.199,
    viewBox: "0 0 16 20.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 40.171c0 1.633-4.026 2.487-8 2.487s-8-.854-8-2.487c0-1.27 2.355-2 4.863-2.306a71.148 71.148 0 0 0 1.493 2.149 2.016 2.016 0 0 0 3.283.008c.417-.569.94-1.312 1.5-2.153 2.511.309 4.861 1.031 4.861 2.302z",
    transform: "translate(-5.605 -22.459)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.853.515a6.426 6.426 0 0 0-6.418 6.422c0 2.764 3.829 8.428 5.449 10.654a1.189 1.189 0 0 0 1.943 0c1.63-2.242 5.449-7.886 5.449-10.654A6.427 6.427 0 0 0 15.853.515zm0 8.208a2.6 2.6 0 1 1 2.607-2.6 2.605 2.605 0 0 1-2.607 2.6z",
    transform: "translate(-7.855 -.515)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.80009a22.svg";
export { ForwardRef as ReactComponent };